import React from "react";
import "./Blogs.css";

const Blogs = () => {
  return (
    <div className="blogs mx-md-5 mx-2">
      <div>
        <h5>
          <span className="text-secondary fw-bold">Question-1:</span> What is
          the purpose of React router ?
        </h5>
        <p>
          <span className="text-primary fw-bold fs-5">Answer :</span> Routing is
          a process in which a user is directed to different pages based on
          their action or request. ReactJS Router is mainly used for developing
          Single Page Web Applications. React Router is used to define multiple
          routes in the application. When a user types a specific URL into the
          browser, and if this URL path matches any 'route' inside the router
          file, the user will be redirected to that particular route.
        </p>
      </div>

      <div>
        <h5>
          <span className="text-secondary fw-bold">Question-2:</span> How does
          Context Api works ?
        </h5>
        <p>
          <span className="text-primary fw-bold fs-5">Answer :</span> The React
          Context API is a way for a React app to effectively produce global
          variables that can be passed around. This is the alternative to "prop
          drilling" or moving props from grandparent to child to parent, and so
          on.
        </p>
      </div>

      <div>
        <h5>
          <span className="text-secondary fw-bold">Question-2:</span> What is
          useRef Hook in reactjs ?
        </h5>
        <p>
          <span className="text-primary fw-bold fs-5">Answer :</span> useRef
          hook is part of the React Hooks API. It is a function which takes a
          maximum of one argument and returns an Object. The returned object has
          a property called current whose value is the argument passed to
          useRef. If you invoke it without an argument, the returned object's
          current property is set to undefined
        </p>
      </div>
    </div>
  );
};

export default Blogs;
